import clsx, { type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-h1', 'text-h2', 'text-h3', 'text-body1', 'text-body2', 'text-body3'],
    },
  },
});

export default function cn(...values: ClassValue[]) {
  return customTwMerge(clsx(values));
}
